import FormField from '@cloudscape-design/components/form-field'
import Checkbox from '@cloudscape-design/components/checkbox'
import SpaceBetween from '@cloudscape-design/components/space-between'

const CHANNELS = [
  { id: 'facebook_post', label: 'Facebook' },
  { id: 'twitter_post', label: 'Twitter / X' },
  { id: 'linkedin_post', label: 'LinkedIn' },
  { id: 'gbp_post', label: 'Google Business Profile' },
  { id: 'blog_seo', label: 'SEO Blog' },
]

interface Props {
  selected: string[]
  onChange: (selected: string[]) => void
}

export function StepChannels({ selected, onChange }: Props) {
  function toggle(id: string) {
    onChange(selected.includes(id) ? selected.filter(s => s !== id) : [...selected, id])
  }
  return (
    <FormField label="Which channels should your agent post to?" stretch>
      <SpaceBetween size="xs">
        {CHANNELS.map(ch => (
          <Checkbox key={ch.id} checked={selected.includes(ch.id)} onChange={() => toggle(ch.id)}>
            {ch.label}
          </Checkbox>
        ))}
      </SpaceBetween>
    </FormField>
  )
}
